/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */

export type QuizPlanOrderResponsePlanType =
  (typeof QuizPlanOrderResponsePlanType)[keyof typeof QuizPlanOrderResponsePlanType];

export const QuizPlanOrderResponsePlanType = {
  FREE: 'FREE',
  BASIC: 'BASIC',
  PRO: 'PRO',
} as const;
